"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const Flex_1 = tslib_1.__importDefault(require("../Elements/Flex"));
const Texts_1 = require("../Texts");
const styles_1 = require("../../styles");
const colorUtils_1 = require("../../helpers/colorUtils");
const StyledFunctions_1 = require("../../helpers/StyledFunctions");
const getBackground = (type) => {
    if (type === 'checkbox') {
        return 'data:image/svg+xml;charset=utf8,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 8 8\'%3E%3Cpath fill=\'%23fff\' d=\'M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z\'/%3E%3C/svg%3E'; // tslint:disable-line
    }
    return 'data:image/svg+xml;charset=utf8,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'-4 -4 8 8\'%3E%3Ccircle r=\'3\' fill=\'%23fff\'/%3E%3C/svg%3E'; // tslint:disable-line
};
const defaultProps = {
    showError: true,
    type: 'checkbox',
};
const Container = (0, styled_components_1.default)(Flex_1.default) ``;
const Label = (0, styled_components_1.default)('label') `
  display: inline-block;
  position: relative;
  padding-left: 1.5rem;
  line-height: 1.5;
  cursor: pointer;
`;
const Text = (0, styled_components_1.default)(Texts_1.NormalText) `
  user-select: none;
  &:before,
  &:after {
    position: absolute;
    content: '';
    left: 0;
    top: 0.05rem;
    width: 1rem;
    height: 1rem;
    border: 1px solid ${styles_1.Colors.Border};
    border-radius: ${props => (props.type === 'checkbox' ? '3px' : '50%')};
    user-select: none;
  }
  &:before {
    background: white;
  }
  &:after {
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 50% 50%;
  }
`;
const Input = (0, styled_components_1.default)('input') `
  position: absolute;
  left: 0;
  z-index: -1;
  opacity: 0;
  &:disabled ~ ${Text} {
    color: ${styles_1.Colors.Secondary};
    cursor: not-allowed;
  }
  &:disabled ~ ${Text}:before {
    background: ${(0, colorUtils_1.lighten)(styles_1.Colors.Secondary, 0.15)};
  }
  &:checked ~ ${Text}:before {
    background: ${styles_1.Colors.Primary};
  }
  &:checked ~ ${Text}:after {
    ${props => props.type && `background-image: url("${getBackground(props.type)}")`};
  }
  &:checked:disabled ~ span:before {
    background: ${(0, colorUtils_1.lighten)(styles_1.Colors.Primary, 0.15)};
  }
`;
const CheckboxInput = ({ label, error, hint, showError, ...restProps }) => {
    const { margins, paddings, rest } = (0, StyledFunctions_1.extractMarginAndPadding)(restProps);
    return (react_1.default.createElement(Container, { ...margins, ...paddings },
        react_1.default.createElement(Label, null,
            react_1.default.createElement(Input, { type: "checkbox", ...rest }),
            react_1.default.createElement(Text, { type: rest.type }, label)),
        showError && react_1.default.createElement(Texts_1.HintText, { error: !!error },
            "\u00A0",
            error || hint)));
};
CheckboxInput.defaultProps = defaultProps;
exports.default = CheckboxInput;
